// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 20px;
}

.pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
}

.pagination-btn:hover:not(:disabled) {
  background: var(--accent-soft);
  color: var(--accent);
  border-color: var(--accent);
}

.pagination-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.pagination-num {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  font-size: 13px;
  font-family: var(--font-mono);
  cursor: pointer;
  transition: all 0.15s;
}

.pagination-num:hover {
  background: var(--accent-soft);
  color: var(--accent);
  border-color: var(--accent);
}

.pagination-num.active {
  background: var(--accent);
  color: white;
  border-color: var(--accent);
}

.pagination-dots {
  color: var(--text-muted);
  font-size: 14px;
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/Pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 20px;\n}\n\n.pagination-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: var(--accent-soft);\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.pagination-num {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  height: 36px;\n  padding: 0 8px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-family: var(--font-mono);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.pagination-num:hover {\n  background: var(--accent-soft);\n  color: var(--accent);\n  border-color: var(--accent);\n}\n\n.pagination-num.active {\n  background: var(--accent);\n  color: white;\n  border-color: var(--accent);\n}\n\n.pagination-dots {\n  color: var(--text-muted);\n  font-size: 14px;\n  padding: 0 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
